const CourseUnit = {
  first: 1,
  last: 4,
};

export default CourseUnit;
